import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { fetchMemberships } from '../../actions/members';
import CacheService from '../../services/cacheService';
import viewHelper from '../../helpers/view';
import Spinner from '../shared/spinner';
import NoRecordFound from '../shared/noRecordFound';
import MemberInfo from '../shared/memberInfo';

class Memberships extends Component {

	componentDidMount() {
		this.props.fetchMemberships();
	}

	renderMemberships() {
		let memberships = viewHelper.getSortedMemberships(this.props.memberships);
		if(memberships.length > 0) {
			return _.map(memberships, (membership) => {
				return (
					<div className="media item" key={membership.id}>
						<div className="media-body">
							<h4 className="media-heading">
								<Link to={`/${CacheService.getToken().bname}/memberships/${membership.id}`}>
									{membership.id} - {membership.activity}
									<span className={`badge ${viewHelper.membershipHasActiveStatus(membership.status_code) ? 'badge-success' : 'badge-danger'}`}>{membership.status}</span>
								</Link>
							</h4>
							<div className="column">
								<span className="label-heading">Start:</span>
								<span className="label-text">{viewHelper.getFormattedDate(membership.start_date)}</span>
							</div>
							<div className="column">
								<span className="label-heading">End:</span>
								<span className="label-text">{viewHelper.getFormattedDate(membership.end_date)}</span>
							</div>
							<div className="column">
								<span className="label-heading">Amount:</span>
								<span className="label-text">{viewHelper.formatCurrency(membership.total_amount)}</span>
							</div>
							<div className="column">
								<span className="label-heading">Payment Type:</span>
								<span className="label-text">{membership.payment_type}</span>
							</div>
							<div className="column">
								<span className="label-heading">Visits:</span>
								<span className="label-text">{membership.visits}</span>
							</div>
							<div className="column">
								<span className="label-heading">Visits Remaining:</span>
								<span className="label-text">{membership.visits_remaining}</span>
							</div>
						</div>
					</div>
				)
			});
		} else {
			return <NoRecordFound/>;
		}
	}

	render () {
		const { member, memberships } = this.props;
		if(!memberships) {
			return (
				<div className="container content">
					<Spinner />
				</div>
			);
		} else {
			return (
				<div className="container content">
					<MemberInfo title={`${viewHelper.getFullName(member)} - Memberships`} />

					<div className="col-xs-12 col-md-12 col-lg-12 no-padding">
						<div className="row-eq-height">
							<div className="col-xs-12 col-md-12 col-lg-12 no-padding border-bottom">
								<ul className="detail-list">
									{this.renderMemberships()}
								</ul>
							</div>
						</div>
					</div>
				</div>
			);
		}
	}
}

function mapStateToProps(state) {
	const { memberships } = state;
	return {
		memberships
	};
}

export default connect(mapStateToProps, { fetchMemberships })(Memberships);